/**
 * Number formatting helpers. Locale-independent so the UI reads the same way
 * regardless of which browser language the user has set:
 *
 *   fmt(1500)              -> "1 500"
 *   fmt(1500.5, 2)         -> "1 500.50"
 *   fmtMoney(1234.56)      -> "€1 234.56"
 *   fmtMoney(1234, 0)      -> "€1 234"
 *
 * Thousands are separated by a regular space (not the non-breaking space
 * Intl.NumberFormat would produce for sk-SK/cs-CZ/de-DE) so layouts don't
 * wrap or behave inconsistently across browsers.
 */

export function fmt(value: number | string | undefined | null, decimals = 0): string {
  const n = typeof value === 'number' ? value : Number(value ?? 0);
  if (!Number.isFinite(n)) return '0';
  const parts = n.toFixed(decimals).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join('.');
}

export function fmtMoney(value: number | string | undefined | null, decimals = 0): string {
  return `€${fmt(value, decimals)}`;
}
